<!-- 店铺设置/商户等级表单 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="180px"
      >
        <el-form-item label="等级名称" prop="name">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="可发布商品数">
          <el-input v-model="formData.goods_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="可上传图片数">
          <el-input v-model="formData.pic_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="可选模板套数">
          <el-input v-model="formData.tpl_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="收费标准">
          <el-input v-model="formData.cost" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="级别">
          <el-input v-model="formData.level" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="商品免审">
          <!-- <el-radio-group v-model="formData.is_exempt">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group> -->
          <el-input v-model="formData.is_exempt" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="子账号数量">
          <el-input v-model="formData.child_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="门店数量">
          <el-input v-model="formData.shop_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="店员数量">
          <el-input v-model="formData.saller_num" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="提现手续费">
          <el-input
            v-model="formData.withdraw_free"
            class="input_box"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现最小金额">
          <el-input
            v-model="formData.withdraw_limit"
            class="input_box"
          ></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input
            v-model="formData.withdraw_intro"
            class="input_box"
            type="textarea"
            rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="权限分配">
          <div class="checkbox_item">
            <div class="check_label_box">
              <div></div>
              <el-checkbox
                :indeterminate="isIndeterminateAll"
                v-model="allCheck"
                @change="CheckAllCheck"
                >全选</el-checkbox
              >
            </div>
          </div>
          <div
            class="checkbox_item"
            v-for="(item, index) in allAdminList"
            :key="index"
          >
            <div class="check_label_box">
              <span>{{ item.name }}</span>
              <el-checkbox
                :indeterminate="isIndeterminate[index]"
                v-model="allbutton[index]"
                @change="check => CheckAllButton(check, index)"
                >全选</el-checkbox
              >
            </div>
            <div class="check_select_box">
              <el-checkbox-group
                v-model="checked[index]"
                @change="check => checkedItemChange(check, index)"
              >
                <el-checkbox
                  v-for="part in item.list"
                  :key="part"
                  :label="part"
                  class="check_items"
                  >{{ part }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button type="info" class="ml30" @click="goback">返回列表</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { adminList } from "../testData";
import { mapGetters } from "vuex";
import { AddLevel, EditLevel } from "@/api/merchant";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.$store.commit("SET_STATE", "2");
    this.init();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("SET_STATE", "1");
    next();
  },
  data() {
    return {
      formData: {},
      allAdminList: [],
      checked: [[], []], //已选中的选项
      allbutton: [false, false], //全选按钮
      allCheck: false,
      isIndeterminate: [false, false], //不确定全选状态
      isIndeterminateAll: false,
      if_add: true,
      rules: {
        name: [{ required: true, message: "请输入等级名称", trigger: "blur" }]
      }
    };
  },
  methods: {
    init() {
      this.allAdminList = adminList;
      this.formData = this.$route.query.editData || {
        name: ""
      };
      if (this.formData.id) {
        this.if_add = false;
      }
    },
    goback() {
      this.$router.go(-1);
    },
    submit() {
      var data = Object.assign({}, this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      console.log(data);
      if (this.if_add) {
        AddLevel(data).then(res => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.goback();
          }
        });
      } else {
        EditLevel(data).then(res => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.goback();
          }
        });
      }
    },
    // 权限管理多选框
    // 全部全选
    CheckAllCheck(value) {
      this.allAdminList.forEach((item, index) => {
        this.checked[index] = value ? this.allAdminList[index].list : [];
        this.isIndeterminate[index] = false;
        this.allbutton[index] = value;
      });
      this.isIndeterminateAll = false;
    },
    // 商品管理全选
    CheckAllButton(val, index) {
      this.checked[index] = val ? this.allAdminList[index].list : [];
      this.isIndeterminate[index] = false;
      this.allSelect();
    },
    // 商品管理选项变化
    checkedItemChange(value, index) {
      console.log(this.allAdminList[index].list.length);
      var checkedCount = value.length;
      console.log(checkedCount);
      this.allbutton[index] =
        checkedCount === this.allAdminList[index].list.length;
      console.log(this.allbutton[index]);
      this.isIndeterminate[index] =
        checkedCount > 0 && checkedCount < this.allAdminList[index].list.length;
      console.log(this.isIndeterminate[index]);
      this.allSelect();
    },
    //判断全部全选
    allSelect() {
      var all = true;
      this.checked.forEach((item, index) => {
        if (item.length < this.allAdminList[index].list.length) {
          all = false;
        }
      });
      this.checked.forEach(item => {
        if (item.length > 0) {
          all = false;
        }
      });
      console.log(all);
      if (all) {
        this.isIndeterminateAll = false;
        if (this.checked[0].length > 0) {
          this.allCheck = true;
        } else {
          this.allCheck = false;
        }
      } else {
        this.isIndeterminateAll = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    overflow: auto;
    .input_box {
      width: 320px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    // 多选框
    .checkbox_item {
      display: flex;
      .check_label_box {
        width: 145px;
        border-right: 1px solid #dfdfdf;
        span {
          margin-right: 10px;
        }
        div {
          display: inline-block;
          width: 66px;
        }
      }
      .check_select_box {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding-left: 20px;
        .check_items {
          width: 120px;
        }
      }
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
  }
}
</style>
